import React from "react";
import { Tooltip } from "antd";
 
const AllToolTip = ({ text, children, placement = "top" }) => {
  return (
    <Tooltip placement={placement} title={text}>
      <i className="fas fa-info-circle icon-lg text-white cursor-pointer ml-3"></i>
    </Tooltip>
  );
};
 
export default AllToolTip;